import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function scrollTo(_x) {
  return _scrollTo.apply(this, arguments);
}

function _scrollTo() {
  _scrollTo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(el) {
    var options,
        scroll,
        currentScrollPosition,
        scrollProperty,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};

            if (!(!(el instanceof Element) && !(el instanceof Window))) {
              _context.next = 3;
              break;
            }

            throw new Error("element passed to scrollTo() must be either the window or a DOM element, you passed ".concat(el, "!"));

          case 3:
            options = sanitizeScrollOptions(options);

            scroll = function scroll(from, to, prop, startTime) {
              var duration = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 300;
              var easeFunc = arguments.length > 5 ? arguments[5] : undefined;
              var callback = arguments.length > 6 ? arguments[6] : undefined;
              window.requestAnimationFrame(function () {
                var currentTime = Date.now();
                var time = Math.min(1, (currentTime - startTime) / duration);

                if (from === to) {
                  return callback ? callback() : null;
                }

                setScrollPosition(el, easeFunc(time) * (to - from) + from);
                /* prevent scrolling, if already there, or at end */

                if (time < 1) {
                  scroll(from, to, prop, startTime, duration, easeFunc, callback);
                } else if (callback) {
                  callback();
                }
              });
            };

            currentScrollPosition = getScrollPosition(el);
            scrollProperty = getScrollPropertyByElement(el);
            return _context.abrupt("return", new Promise(function (resolve) {
              scroll(currentScrollPosition, typeof options.top === 'number' ? options.top : currentScrollPosition, scrollProperty, Date.now(), options.duration, getEasing(options.easing), resolve);
            }));

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _scrollTo.apply(this, arguments);
}

function scrollIntoView(element, scroller, options) {
  validateElement(element);

  if (scroller && !(scroller instanceof Element)) {
    options = scroller;
    scroller = undefined;
  }

  var _sanitizeScrollOption = sanitizeScrollOptions(options),
      duration = _sanitizeScrollOption.duration,
      easing = _sanitizeScrollOption.easing;

  scroller = scroller || utils.getDocument().body;
  var currentContainerScrollYPos = 0;
  var elementScrollYPos = element ? element.offsetTop : 0;
  var document = utils.getDocument(); // if the container is the document body or document itself, we'll
  // need a different set of coordinates for accuracy

  if (scroller === document.body || scroller === document.documentElement) {
    // using pageYOffset for cross-browser compatibility
    currentContainerScrollYPos = window.pageYOffset; // must add containers scroll y position to ensure an absolute value that does not change

    elementScrollYPos = element.getBoundingClientRect().top + currentContainerScrollYPos;
  }

  return scrollTo(scroller, {
    top: elementScrollYPos,
    left: 0,
    duration: duration,
    easing: easing
  });
}

function validateElement(element) {
  if (element === undefined) {
    var errorMsg = 'The element passed to scrollIntoView() was undefined.';
    throw new Error(errorMsg);
  }

  if (!(element instanceof HTMLElement)) {
    throw new Error("The element passed to scrollIntoView() must be a valid element. You passed ".concat(element, "."));
  }
}

function getScrollPropertyByElement(el) {
  var props = {
    window: {
      y: 'scrollY',
      x: 'scrollX'
    },
    element: {
      y: 'scrollTop',
      x: 'scrollLeft'
    }
  };
  var axis = 'y';

  if (el instanceof Window) {
    return props.window[axis];
  } else {
    return props.element[axis];
  }
}

function sanitizeScrollOptions() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (options.behavior === 'smooth') {
    options.easing = 'ease-in-out';
    options.duration = 300;
  }

  if (options.behavior === 'auto') {
    options.duration = 0;
    options.easing = 'linear';
  }

  return options;
}

function getScrollPosition(el) {
  var document = utils.getDocument();

  if (el === document.body || el === document.documentElement || el instanceof Window) {
    return document.body.scrollTop || document.documentElement.scrollTop;
  } else {
    return el.scrollTop;
  }
}

function setScrollPosition(el, value) {
  var document = utils.getDocument();

  if (el === document.body || el === document.documentElement || el instanceof Window) {
    document.body.scrollTop = value;
    document.documentElement.scrollTop = value;
  } else {
    el.scrollTop = value;
  }
}

var utils = {
  // we're really just exporting this so that tests can mock the document.documentElement
  getDocument: function getDocument() {
    return document;
  }
};
var easingMap = {
  linear: function linear(t) {
    return t;
  },
  'ease-in': function easeIn(t) {
    return t * t;
  },
  'ease-out': function easeOut(t) {
    return t * (2 - t);
  },
  'ease-in-out': function easeInOut(t) {
    return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
  }
};

var getEasing = function getEasing(easing) {
  var defaultEasing = 'linear';
  var easeFunc = easingMap[easing || defaultEasing];

  if (!easeFunc) {
    var options = Object.keys(easingMap).join(',');
    throw new Error("Scroll error: scroller does not support an easing option of \"".concat(easing, "\". Supported options are ").concat(options));
  }

  return easeFunc;
};

export { easingMap, scrollIntoView, scrollTo, utils };